// TS twin of iOS `AppEnvironment` enum.
// Contract pinned in `fixtures/url-invocations.json`.
//
// Default is 'localhost' so a bare URL (no `?env=` param) targets the Mac's
// Caddy-fronted assembler at https://assembler.av.io — the typical dev
// workflow. Real App Clip card / storefront URLs explicitly include
// `?env=production` (or `?env=staging`); when those production URLs deploy
// to ar.autoviz.io, the param drives the correct public assembler.

export type AppEnvironment = 'localhost' | 'staging' | 'production'

export const APP_ENVIRONMENT_DEFAULT: AppEnvironment = 'localhost'

export function assemblerBaseURL(env: AppEnvironment): string {
  switch (env) {
    case 'localhost':
      return 'https://assembler.av.io/assemble'
    case 'staging':
      return 'https://staging.assembler.autoviz.io/assemble'
    case 'production':
      return 'https://assembler.autoviz.io/assemble'
  }
}

export function appEnvironment(
  raw: string | null | undefined,
): AppEnvironment {
  if (raw === 'localhost' || raw === 'staging' || raw === 'production') {
    return raw
  }
  return APP_ENVIRONMENT_DEFAULT
}

/** ADR-086 — parts API base, per environment.
 *
 *  Sits beside assemblerBaseURL so the two cannot drift on what an environment
 *  name means. Hosts mirror the assembler worker's own PARTS_API_URL bindings;
 *  local resolves to the Caddy-fronted worker on this machine. */
export function partsApiBaseURL(env: AppEnvironment): string {
  switch (env) {
    case 'localhost':
      return 'https://parts.api.av.io'
    case 'staging':
      return 'https://staging.mpb-client-api.autoviz.io'
    case 'production':
      return 'https://mpb-client-api.autoviz.io'
  }
}
